<template>
    <div class="container">
        <div class="row py-2 mb-5">
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label for="product_system">{{ $lang('Produkt') }}</label>
                    <select :disabled="productSystems.length < 2" class="form-control" id="product_system"
                            v-model="productSystemId">
                        <option v-for="prodSys in productSystems" :value="prodSys.id">
                            {{ prodSys.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label for="module">{{ $lang('Moduł') }}</label>
                    <div class="input-group">

                        <select :disabled="config.length < 2" class="form-control" id="module" v-model="module">
                            <option v-for="moduleWithConfig in config" :value="moduleWithConfig.module_id">
                                {{ moduleWithConfig.module_name }}
                            </option>
                        </select>
                        <div class="input-group-append" v-if="module!==0">
                            <button :title="$lang('Usuń konfigurację dla modułu')" class="btn btn-default" @click.prevent="removeModule">
                                <i class="fa fa-trash"></i>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-12" v-if="modulesToChoose.length > 0">
                <button type="button" class="btn btn-primary pull-right" data-toggle="modal" data-target="#modal_choose_module">{{ $lang('Dodaj moduł') }}</button>
            </div>

        </div>
        <div class="row">
            <div class="col-12">
                <sla-table v-if="config.length > 0" :data="currentTableData" :module-id="module" :product-system-id="productSystemId" :save-url="saveUrl"></sla-table>
            </div>
        </div>
        <div class="modal fade" id="modal_choose_module" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $lang('Wybierz moduł') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group" style="margin-bottom: 0;">
                            <label for="add_module">{{ $lang('Moduł') }}</label>
                            <select class="form-control" id="add_module" v-model="selectedModuleId">
                                <option v-for="moduleToChoose in modulesToChoose" :value="moduleToChoose.module.id">{{
                                        moduleToChoose.module.name
                                    }}
                                </option>
                            </select>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">{{
                                $lang('Zamknij')
                            }}
                        </button>
                        <button :disabled="selectedModuleId === null || selectedModuleId === undefined || selectedModuleId === 0"
                                id="choose-module" @click.prevent="addModule()" type="button" class="btn btn-primary" data-dismiss="modal">
                            {{ $lang('Dodaj') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SlaTable from "./sla-table";
import {EventBus} from "../../mixins/event-bus";
import ShowNotification from "../../mixins/show-notification";

export default {
    name: "sla-config-set",
    components: {SlaTable},
    mixins: [ShowNotification],
    props: {
        libraryId: {
            type: Number,
            required: true
        },
        editable: {
            type: Boolean,
            default: false
        },
        issueTypes: {
            type: Array,
            default: function () {
                return [];
            }
        },
        productSystems: {
            type: Array,
            required: true
        },
        modules: {
            type: Array,
            required: true
        },
        dataUrl: {
            type: String,
            required: true
        },
        saveUrl: {
            type: String,
            required: true
        },
        newModuleUrl: {
            type: String,
            required: true
        },
        detachModuleUrl: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            config: [],
            productSystemId: null,
            module: 0,
            selectedModuleId: 0
        }
    },
    methods: {
        getData() {
            let self = this;
            axios.post(self.dataUrl, {
                     library_id: self.libraryId,
                     product_system_id: self.productSystemId
                 })
                 .then(function (response) {
                     self.config = response.data.config;
                     if (self.module === null || self.module === undefined) {
                         self.module = 0;
                     }
                 })
                 .catch((error) => {
                     console.log(error.response);
                 });
        },
        addModule() {
            let self = this;
            axios.post(self.newModuleUrl, {
                     module_id: self.selectedModuleId,
                     product_system_id: self.productSystemId
                 })
                 .then(function (response) {
                     self.module = self.selectedModuleId;
                     self.selectedModuleId = null;
                     self.getData();
                 })
                 .catch((error) => {
                     console.log(error.response);
                 });
        },
        removeModule() {
            let self = this;
            axios.post(self.detachModuleUrl, {
                     module_id: self.module,
                     product_system_id: self.productSystemId
                 })
                 .then(function (response) {
                     self.module = 0;
                     self.showNotification('success', self.$lang('Ustawienia dla modułu zostały usunięte! Zostaną zastosowane ustawienia ogólne.'));
                     self.getData();
                 })
                 .catch((error) => {
                     self.showNotification('error', self.$lang('Wystąpił błąd przy próbie usunięcia ustawień dla modułu!'));
                     console.log(error.response);
                 });
        }
    },
    watch: {
        productSystemId() {
            this.getData();
        }
    },
    computed: {
        modulesWithConfig() {
            return this.config.filter(function (item) {
                return item.module_id !== 0;
            });
        },
        modulesToChoose() {
            let self = this;

            return this.modules.filter(function (item) {
                return self.modulesWithConfig.filter(function (item_c) {
                    return item_c.module_id === item.module.id;
                }).length === 0;
            });
        },
        currentTableData() {
            let self = this;
            return this.config.filter(function (item) {
                return item.module_id === self.module;
            })[0];
        }
    },
    created() {
        this.productSystemId = this.productSystems[0].id

        this.getData();
    },
    mounted() {
        let self = this;
        EventBus.$on('refreshSlaTable', () => {
            self.getData();
        })
    }
}
</script>

<style scoped>

</style>
